export default function redirect() {
  if (window.location.pathname.startsWith('/article/author')) {
    const slug = window.location.pathname.split('/').filter(Boolean).at(-1);
    window.location.href = `/author/${slug}`;
  }
  if (window.location.pathname === '/article/') {
    window.location.href = '/blog';
  }
}
